import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
type FAQItem = {
  question: string;
  answer: string;
};
const faqs: FAQItem[] = [{
  question: '¿Ya leí muchos libros y no funcionaron?',
  answer: 'Exactamente por eso existe Crecimiento AudioPro. Los libros convencionales informan. Estos reprograman. El formato importa tanto como el contenido. No es lo mismo leer sobre nadar que estar en el agua.'
}, {
  question: '¿No tengo tiempo?',
  answer: 'Los protocolos van de 5 a 20 minutos. Los audiolibros funcionan mientras haces otra cosa — caminas, manejas, entrenas. El tiempo no es el problema. La prioridad sí.'
}, {
  question: '¿Es lo mismo de siempre?',
  answer: 'Si lo fuera, no estarías leyendo hasta aquí. La diferencia está en el mecanismo: audio estratégico + meditación de intervención + protocolos subconscientes. No motivación. Reprogramación.'
}, {
  question: '¿Funciona para finanzas o solo para espiritualidad?',
  answer: 'Ambas. Porque aquí entendemos que son el mismo sistema. Tu mente determina tu dinero. Tu energía determina tus decisiones financieras. Trabajamos los dos sin que uno sabotee al otro.'
}, {
  question: '¿Y si no me funciona?',
  answer: 'Tienes garantía completa a través de Hotmart. Sin preguntas, sin procesos complicados. La única forma de perder es no intentarlo.'
}];
function FAQItem({
  item,
  index
}: {
  item: FAQItem;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: index * 0.1,
    duration: 0.5
  }} className="rounded-sm overflow-hidden" style={{
    border: '1px solid var(--color-border)'
  }} data-id="element-95">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left transition-colors" style={{
      background: isOpen ? 'var(--color-surface-2)' : 'var(--color-surface)',
      color: 'var(--color-text)'
    }} aria-expanded={isOpen} data-id="element-96">
        <span className="text-base font-semibold pr-4" data-id="element-97">{item.question}</span>
        <span className="flex-shrink-0" style={{
        color: 'var(--color-accent)'
      }} data-id="element-98">
          {isOpen ? <MinusIcon className="w-5 h-5" data-id="element-99" /> : <PlusIcon className="w-5 h-5" data-id="element-100" />}
        </span>
      </button>

      <AnimatePresence data-id="element-101">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} style={{
        overflow: 'hidden'
      }} data-id="element-102">
            <div className="px-6 pb-6" style={{
          background: 'var(--color-surface-2)'
        }} data-id="element-103">
              <p className="text-base leading-relaxed" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-104">
                {item.answer}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4" style={{
    background: 'var(--color-surface)'
  }} data-id="element-105">
      <div className="max-w-2xl mx-auto" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-14" data-id="element-107">
          <p className="text-sm font-semibold tracking-widest uppercase mb-6" style={{
          color: 'var(--color-accent)'
        }} data-id="element-108">
            Preguntas frecuentes
          </p>
          <h2 className="text-3xl md:text-4xl font-black leading-tight" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text)'
        }} data-id="element-109">
            Manejo de Objeciones
          </h2>
        </motion.div>

        {isInView && <div className="space-y-3" data-id="element-110">
            <FAQItem item={faqs[0]} index={0} data-id="element-111" />
            <FAQItem item={faqs[1]} index={1} data-id="element-112" />
            <FAQItem item={faqs[2]} index={2} data-id="element-113" />
            <FAQItem item={faqs[3]} index={3} data-id="element-114" />
            <FAQItem item={faqs[4]} index={4} data-id="element-115" />
          </div>}
      </div>
    </section>;
}